export default {
  en: {
    emailConfiguration: 'Email Configuration',
    senderName: 'Sender Name',
    replyEmail: 'Reply Email',
    ccEmail: 'Cc Email',
    bccEmail: 'Bcc Email',
    addCcEmail: '+ Add Cc Email',
    addBccEmail: '+ Add Bcc Email',
    saveEmailConfigurationSuccessTitle: 'Success',
    saveEmailConfigurationSuccessMessage: 'Save email configuration success',
    saveChanges: 'Save Changes',
    cancel: 'Cancel'
  },
  th: {
    emailConfiguration: 'การตั้งค่าอีเมล',
    senderName: 'ชื่อผู้ส่ง',
    replyEmail: 'อีเมลตอบกลับ',
    ccEmail: 'Cc อีเมล',
    bccEmail: 'Bcc อีเมล',
    addCcEmail: '+ เพิ่ม Cc อีเมล',
    addBccEmail: '+ เพิ่ม Bcc อีเมล',
    saveEmailConfigurationSuccessTitle: 'สำเร็จ',
    saveEmailConfigurationSuccessMessage: 'บันทึกการตั้งค่าอีเมลสำเร็จ',
    saveChanges: 'บันทึก',
    cancel: 'ยกเลิก'
  }
}
